import type { TypographyVariantsOptions } from '@mui/material/styles'

const fontFamily = [
  '"Inter"',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(', ')

export const typography: TypographyVariantsOptions = {
  fontFamily,
  h1: { fontWeight: 700, fontSize: '2.5rem', letterSpacing: '-0.02em', lineHeight: 1.2 },
  h2: { fontWeight: 700, fontSize: '2rem', letterSpacing: '-0.02em', lineHeight: 1.25 },
  h3: { fontWeight: 600, fontSize: '1.625rem', letterSpacing: '-0.01em', lineHeight: 1.3 },
  h4: { fontWeight: 600, fontSize: '1.375rem', letterSpacing: '-0.01em', lineHeight: 1.35 },
  h5: { fontWeight: 600, fontSize: '1.125rem', lineHeight: 1.4 },
  h6: { fontWeight: 600, fontSize: '1rem', lineHeight: 1.4 },
  subtitle1: { fontWeight: 500, fontSize: '0.9375rem', lineHeight: 1.5 },
  subtitle2: { fontWeight: 500, fontSize: '0.8125rem', lineHeight: 1.5, color: '#94A3B8' },
  body1: { fontSize: '0.9375rem', lineHeight: 1.6 },
  body2: { fontSize: '0.8125rem', lineHeight: 1.6 },
  button: { fontWeight: 600, textTransform: 'none', letterSpacing: 0 },
  caption: { fontSize: '0.75rem', color: '#94A3B8' },
  overline: { fontSize: '0.6875rem', fontWeight: 600, letterSpacing: '0.08em' },
}
